import assign from 'object-assign';
import IFeatureState from '../../store/IFeatureState';
import * as ActionTypes from './ActionTypes';
import InitialState from './InitialState';

export default function planFirmReducer(
    state: any = InitialState.planFirms,
    action: { type: string; result: any }
): any {
    let newState: IFeatureState;

    switch (action.type) {
        case ActionTypes.LIST_PLAN_FIRMS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.result;
            return newState;

        case ActionTypes.CREATE_PLAN_FIRM_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;

        case ActionTypes.EDIT_PLAN_FIRM_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            newState.edit = assign({}, action.result);
            return newState;

        case ActionTypes.UPDATE_PLAN_FIRM_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;

        case ActionTypes.DELETE_PLAN_FIRM_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list.filter((x: any) => x.id !== action.result)];
            return newState;

        default:
            return state;
    }
}
